export default __webpack_public_path__ + "static/media/TH.d390450d.png";